import React from 'react';

const SheafCancel = () => (
  <div className="p-4">
    <h2>Payment Cancelled</h2>
    <p>Your Sheaf purchase was cancelled.</p>
  </div>
);

export default SheafCancel;
